<template>
  <VaccinationPage
    title="Heart Disease"
    :buttons="buttons"
    baseRoute="/HeartDiseaseSecondPage"
    :bottomImage="require('@/assets/page16/Asset 141.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/HeartDiseaseSecondPage"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page16/Asset 129.png"), name: "Influenza" },
  { imgPath: require("@/assets/page16/Asset 130.png"), name: "Pneumococcal" },
  { imgPath: require("@/assets/page16/Asset 131.png"), name: "RSV" },
  { imgPath: require("@/assets/page16/Asset 132.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page16/Asset 133.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page16/Asset 134.png"), name: "HepatitisB" },
  { imgPath: require("@/assets/page16/Asset 135.png"), name: "Zoster" },
  { imgPath: require("@/assets/page16/Asset 136.png"), name: "MMR" },
  { imgPath: require("@/assets/page16/Asset 137.png"), name: "Varicella" },
  { imgPath: require("@/assets/page16/Asset 138.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page16/Asset 139.png"), name: "MeningococcalMenB" },
  { imgPath: require("@/assets/page16/Asset 140.png"), name: "Humanpapilloma" },
];
</script>
